import { Cell, State } from "./types";

export interface MoveToNextCellAction {
  key: string;
  shiftKey: boolean;
  type: "MOVE TO NEXT CELL";
}

export const horizontalProximity = (cell1 : Cell, cell2: Cell) => {
  return Math.abs(cell1.maxX - cell2.maxX) + Math.abs(cell1.minX - cell2.minX);
}

export const verticalProximity = (cell1 : Cell, cell2: Cell) => {
  return Math.abs(cell1.maxY - cell2.maxY) + Math.abs(cell1.minY - cell2.minY);
}

export const moveToNextCell = (
  state: State,
  action: MoveToNextCellAction,
): State => {
  let selectedCell = state.cells.find(x => x.selected);
  if (!selectedCell) {
    selectedCell = state.cells[0];
  }


  let nextCell : Cell = null;
  switch (action.key) {
    case "arrowup":
      let topNeighbors = state.cells.filter(x => x.maxY === selectedCell?.minY);
      topNeighbors.sort((x1, x2) => horizontalProximity(x1, selectedCell) - horizontalProximity(x2, selectedCell))
      nextCell = topNeighbors[0];

      if (!nextCell) {
        const biggestY = Math.max(...state.cells.map(x => x.maxY));
        let lastRow = state.cells.filter(x => x.maxY === biggestY);
        lastRow.sort((x1, x2) => horizontalProximity(x1, selectedCell) - horizontalProximity(x2, selectedCell))
        nextCell = lastRow[0]; 
      }

      break;
    case "arrowdown":
      let botNeighbors = state.cells.filter(x => x.minY === selectedCell?.maxY);
      botNeighbors.sort((x1, x2) => horizontalProximity(x1, selectedCell) - horizontalProximity(x2, selectedCell))
      nextCell = botNeighbors[0];

      if (!nextCell) {
        const smallestY = Math.min(...state.cells.map(x => x.minY));
        let firstRow = state.cells.filter(x => x.minY === smallestY);
        firstRow.sort((x1, x2) => horizontalProximity(x1, selectedCell) - horizontalProximity(x2, selectedCell))
        nextCell = firstRow[0]; 
      }

      break;
    case "arrowright":
      let rightNeighbors = state.cells.filter(x => x.minX === selectedCell?.maxX);
      rightNeighbors.sort((x1, x2) => verticalProximity(x1, selectedCell) - verticalProximity(x2, selectedCell))
      nextCell = rightNeighbors[0]; 

      if (!nextCell) {
        const smallestX = Math.min(...state.cells.map(x => x.minX));
        let firstCol = state.cells.filter(x => x.minX === smallestX);
        firstCol.sort((x1, x2) => verticalProximity(x1, selectedCell) - verticalProximity(x2, selectedCell))
        nextCell = firstCol[0]; 
      }

      break;
    case "arrowleft":
      let leftNeighbors = state.cells.filter(x => x.maxX === selectedCell?.minX);
      leftNeighbors.sort((x1, x2) => verticalProximity(x1, selectedCell) - verticalProximity(x2, selectedCell))
      nextCell = leftNeighbors[0];

      if (!nextCell) {
        const biggestX = Math.max(...state.cells.map(x => x.maxX));
        let lastCol = state.cells.filter(x => x.maxX === biggestX);
        lastCol.sort((x1, x2) => verticalProximity(x1, selectedCell) - verticalProximity(x2, selectedCell))
        nextCell = lastCol[0]; 
      }

      break;
    case "tab": 
      if (!action.shiftKey) {
        let selectedIndex = state.cells.findIndex(x => x.selected);
        if (selectedIndex !== -1) {
          let nextIndex = selectedIndex + 1;
          if (nextIndex < state.cells.length) {
            nextCell = state.cells[nextIndex];
          }
        }
      } else {
        let selectedIndex = state.cells.findIndex(x => x.selected);
        if (selectedIndex !== -1) {
          let nextIndex = selectedIndex - 1;
          if (nextIndex >= 0) { 
            nextCell = state.cells[nextIndex];
          }
        }
      }

      break;
  }
  if (!nextCell) {
    return state;
  }
  let newCells = state.cells
    .map(c => {
      if (c == nextCell) {
        return {
          ...nextCell,
          selected: true
        }
      }
      return {
        ...c,
        selected:false
      };
    })

    return {
      ...state,
      cells:newCells,
      // reset the "number combo" hotkey state to zero when changing the selected cell
      selectedCellTypeGroup: null
    }
  }

